import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ChangePasswordInjection } from "features/changePassword/di/ChangePasswordInjection";
import { injectable } from "tsyringe";
import { ChangePasswordRequestEntity } from "../entities/ChangePasswordRequestEntity";
import { IChangePasswordRepository } from "../repositories/IChangePasswordRepository";

@injectable()
export class ChangePasswordUseCase {
  private changePassRepo: IChangePasswordRepository;

  constructor() {
    this.changePassRepo = ChangePasswordInjection.getRepo();
  }

  async changePassword(
    body: ChangePasswordRequestEntity,
  ): Promise<BaseApiResponseModel<any>> {
    return await this.changePassRepo.changePassword(body);
  }
}
